import { render, staticRenderFns } from "./ShowTicket.vue?vue&type=template&id=40042d5c"
import script from "./ShowTicket.vue?vue&type=script&lang=js"
export * from "./ShowTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports